/**
 * Centralized route constants for the Carvy application
 * 
 * This file contains all route paths used throughout the application.
 * Update these values for production or when routes change.
 */

export const ROUTES = {
  // Public Routes
  HOME: '/',
  VEHICLES: '/vehicles',
  HELP: '/help',
  
  // Authentication Routes
  LOGIN: '/login',
  REGISTER: '/register',
  AUTH_CALLBACK: '/auth/callback',
  AUTH_ERROR: '/auth/error',
  
  // Agency Routes
  BECOME_PARTNER: '/become-partner',
  
  // Dashboard Routes
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_AUDIT_LOGS: '/admin/audit-logs',
  ADMIN_PENDING_AGENCIES: '/admin/pending-agencies',
  VENDOR_DASHBOARD: '/vendor/dashboard',
  USER_DASHBOARD: '/user/dashboard',
  
  // Admin Vehicle Management Routes
  ADMIN_VEHICLES_FEATURES: '/admin/vehicles/features',
  ADMIN_VEHICLES_TYPES: '/admin/vehicles/types',
  ADMIN_VEHICLES_LOCATIONS: '/admin/vehicles/locations',
  ADMIN_VEHICLES_MAKES: '/admin/vehicles/makes',
  ADMIN_VEHICLES_MODELS: '/admin/vehicles/models',
  ADMIN_VEHICLES_ODOMETER: '/admin/vehicles/odometer',
  ADMIN_VEHICLES_FUEL_TYPES: '/admin/vehicles/fuel-types',
  ADMIN_VEHICLES_PAYOUT_METHODS: '/admin/vehicles/payout-methods',
  ADMIN_VEHICLES_RULES: '/admin/vehicles/rules',
  ADMIN_VEHICLES_CANCELLATION_POLICIES: '/admin/vehicles/cancellation-policies',
  ADMIN_VEHICLES_CANCELLATION_REASONS: '/admin/vehicles/cancellation-reasons',
  ADMIN_REJECTION_REASONS: '/admin/vehicles/rejection-reasons',
  ADMIN_VEHICLES_ADD: '/admin/vehicles/add',
  ADMIN_VEHICLES_EDIT: '/admin/vehicles/edit/:id',
  ADMIN_VEHICLES_EDIT_BY_ID: (id) => `/admin/vehicles/edit/${id}`,
  ADMIN_VEHICLES_REVIEW: '/admin/vehicles/review/:id',
  ADMIN_VEHICLES_REVIEW_BY_ID: (id) => `/admin/vehicles/review/${id}`,
  ADMIN_VEHICLES_LIST: '/admin/vehicles/list',
  ADMIN_VEHICLES_SETTINGS: '/admin/vehicles/settings',
  
  // Admin Bookings Routes
  ADMIN_BOOKINGS: '/admin/bookings',
  
  // Admin Users Routes
  ADMIN_USERS: '/admin/users',
  
  // Admin Agencies Routes
  ADMIN_AGENCIES: '/admin/agencies',
  ADMIN_AGENCY_DETAILS: '/admin/agences/:id',
  ADMIN_AGENCY_DETAILS_BY_ID: (id) => `/admin/agences/${id}`,
  
  // Vendor Routes
  VENDOR_VEHICLES: '/vendor/vehicles',
  VENDOR_VEHICLES_ADD: '/vendor/vehicles/add',
  VENDOR_VEHICLES_EDIT: '/vendor/vehicles/edit/:id',
  VENDOR_VEHICLES_EDIT_BY_ID: (id) => `/vendor/vehicles/edit/${id}`,
  VENDOR_VEHICLES_LIST: '/vendor/vehicles/list',
  VENDOR_BOOKINGS: '/vendor/bookings',
  VENDOR_EARNINGS: '/vendor/earnings',
  
  // Booking Routes
  BOOKING: '/booking/:vehicleId',
  BOOKING_BY_ID: (vehicleId) => `/booking/${vehicleId}`,
  
  // API Routes (for reference, actual API calls should use API_BASE_URL)
  // [REF: CONFIG-001] Configuration de l'URL de l'API
  // Mode DÉVELOPPEMENT (actif) : utilise localhost pour le développement local
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://carvy.tech/api',
  // [REF: CONFIG-002] Mode PRODUCTION (commenté) : décommentez pour la production
  // API_BASE_URL: process.env.REACT_APP_API_URL || 'http://72.62.25.49:5000/api',
  
  // Google OAuth
  GOOGLE_AUTH: '/auth/google',
};

/**
 * Helper function to build full API URL
 * @param {string} endpoint - API endpoint (e.g., '/auth/register')
 * @returns {string} Full API URL
 */
export const buildApiUrl = (endpoint) => {
  const baseUrl = ROUTES.API_BASE_URL;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

/**
 * Helper function to check if current path matches a route
 * @param {string} pathname - Current pathname
 * @param {string} route - Route to check against
 * @returns {boolean} True if pathname matches route
 */
export const isRoute = (pathname, route) => {
  return pathname === route;
};

export default ROUTES;

